var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHappyColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 155,
    fill: "none",
    viewBox: "0 0 154 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.665,
    cy: 77.665,
    r: 76.665,
    fill: "#89E780"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "M61.344 59.385c0 7.747-5.47 14.027-12.217 14.027-6.747 0-12.216-6.28-12.216-14.027 0-7.746 5.469-14.025 12.216-14.025 6.748 0 12.217 6.279 12.217 14.025ZM116.423 59.385c0 7.747-5.47 14.027-12.216 14.027-6.747 0-12.216-6.28-12.216-14.027 0-7.746 5.47-14.025 12.216-14.025 6.746 0 12.216 6.279 12.216 14.025Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.21 55.224a4.435 4.435 0 1 1-8.871-.001 4.435 4.435 0 0 1 8.87.001ZM106.29 55.224a4.436 4.436 0 0 1-8.87 0 4.434 4.434 0 1 1 8.87 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "m109.872 106.008-.073-.072c-2.299-1.991-6.099-1.431-9.012.597a37.802 37.802 0 0 1-12.543 5.755c-3.584 1.087-7.493 1.684-11.584 1.684-4.108 0-8.017-.597-11.618-1.701a37.863 37.863 0 0 1-12.488-5.738c-2.915-2.028-6.715-2.588-9.014-.597l-.09.072c-2.28 1.936-1.666 6.497 1.954 9.611 7.959 6.83 17.715 10.861 27.895 11.954 1.11.066 2.23.111 3.368.111 1.14 0 2.263-.045 3.376-.111 10.179-1.094 19.933-5.124 27.875-11.954 3.637-3.114 4.253-7.675 1.954-9.611Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHappyColor);
export default __webpack_public_path__ + "static/media/icon-happy-color.a9156c3be8407b7cb5717b2636548899.svg";
export { ForwardRef as ReactComponent };